const contentful = require('contentful');
// use default environment config for convenience
// these will be set via `env` property in nuxt.config.js

const config = {
	aod: {
		accessToken: 'Rn6H2vO5CtMMgZHXOlP46dYRlhRnWpM2Q4bGFEE9tmI',
		space: 'lqda40k4ei6l'
	},
	b2s: {
		accessToken: 'XPLs6JRufhHm356o3sCSKAuXLNyEK0MnAPJSmGd4hWI',
		space: 'm58u4vvspw4d'
	},
	dgtl: {
		accessToken: 'MuefwHzzVIy2jvu08Y8WC0XtYWFcDeikUDIGh7lRx5M',
		space: 'zdnt50ygkxg4'
	},
	dominator: {
		accessToken: 'VszdIusvOwAwhYdw3amTM3oMAmGDV1gPycjGWJo60bM',
		space: '07gtnhvp2p2z'
	},
	elrow: {
		accessToken: 'zIKQv29a8WW5wIWp6u9uzuS3B5Ug7tlcDf1Yd_Fy9Zw',
		space: 'by67ad61r27f'
	},
	pleinvrees: {
		space: '50x3b534y93x',
		accessToken: 'ANybqLecXgPn9tbnhF7rMSlfJyG81zZxKgOWnmoIpCs'
	},
	pleinvrees: {
		space: '50x3b534y93x',
		accessToken: 'ANybqLecXgPn9tbnhF7rMSlfJyG81zZxKgOWnmoIpCs'
	},
	festivalmacumba: {
		accessToken: 'zDolYjFq8-vaBmsMxO51Hg66l5vc3qibXHaKWHn1BQc',
		space: 'k539qxk3c2i3'
	},
	gardensofbabylon: {
		accessToken: 'e6lgBtJAbYLA4-CmjysY7Nz7pvCqDh3u7_WMtb9rSJI',
		space: 'ya99blg7ct88'
	},
	idt: {
		accessToken: '7ThNFhhhYhpy4R7new1U7mLEmPaT6gg1aoNu17KWUdE',
		space: 'iipwixlm3c5m'
	},
	macumba: {
		accessToken: 'zDolYjFq8-vaBmsMxO51Hg66l5vc3qibXHaKWHn1BQc',
		space: 'k539qxk3c2i3'
	},
	mananamanana: {
		accessToken: 'ZFiUEG3NON148intVVBqsFTo3N4Ayih49E_2aN7EP8c',
		space: 'wefr971wr3hq'
	},
	mastersofhardcore: {
		accessToken: 't2BVF3C9t1qEIxWUPMgdwnQhl1jl7BibJGHMkb-j5PU',
		space: '68a0vkadohr6'
	},
	milkshake: {
		accessToken: 'SdVL5gPP2X_l0LxwMqfoDedRkXSlg6wKvxLUmIe0kMQ',
		space: 'guiecsus31md'
	},
	mysteryland: {
		accessToken: 'yEXo8P5scRjntVXb29uKHAY7Wdxd9k7TktOjGOnN8y0',
		space: '1xjdot7bc0lp'
	},
	openair: {
		accessToken: 'KywzpErOjY3cUV-NIf6NAPCyup99UBogRjhBayqPcHQ',
		space: 'ozp3pw0jbbzt'
	},
	qdance: {
		accessToken: 'Aas_tydOcahVSPrINieS6jp62RqmChsx4Ld4lPgSDB4',
		space: '6rsk0v0vruzt'
	},
	sensation: {
		accessToken: 'DG4JELDpdbWJKZFnpW_4LMQJN57YAWA67beE5VzsPjg',
		space: '33f909biqish'
	},
	strafwerk: {
		accessToken: 'GnTGwL_i8yQtLW4oDlidzoH8Cha0q7MXQ0NyPMKotMQ',
		space: 'ajhr07wofwed'
	},
	thunderdome: {
		accessToken: 'D2KPyD2ihg3cDYgKCCGdP1QK2SrDYs-DdPDXcnAJNUE',
		space: 'rnthyfkha2q3'
	},
	vunzigedeuntjes: {
		accessToken: 'GU9sz1LkuoBuBsnMp9HVJV4uLFZpy3bEb8nTylKY8lY',
		space: 'z3tkag6y2c3l'
	},
	zwartecross: {
		accessToken: 'Wr-UYpSnbXjt7TAH1zPGiWZ5VoLScwPInyByzi37mPo',
		space: 'vd20yvkphkqn'
	}
}[process.env.SHOPBRAND];

// export `createClient` to use it in page components
module.exports = {
	createClient() {
		return contentful.createClient(config);
	}
};
